// extracted by mini-css-extract-plugin
module.exports = {"like-icon":"_5131f","likeIcon":"_5131f"};